import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './auth/AuthProvider'
import { ErrorBoundary } from './components/layout/ErrorBoundary'
import { LiveRegionProvider } from './lib/announce'
import { AppRoutes } from './routes'
import { ApiError } from './lib/api'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      refetchOnWindowFocus: false,
      // A 401 is handled by the API client (refresh, then route to login) and
      // a 403/404 will never fix itself, so only transport failures retry.
      retry: (failureCount, error) =>
        error instanceof ApiError && error.isOffline && failureCount < 2,
    },
  },
})

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          {/* The live regions must exist before any route can announce into them. */}
          <LiveRegionProvider>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </LiveRegionProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
